import { u2000GetActiveDisplayTimezone } from '../../u2000Core/tools/U2000DateTimeHelpers';
import type { U3500NasSyncStatus } from '../../u3500GedDocumentSearch/U3500Service';

export function u3121NasSyncBadgeClass(status: U3500NasSyncStatus): string {
  switch (status) {
    case 'success':
      return 'bg-green-100 text-green-800';
    case 'error':
      return 'bg-red-100 text-red-800';
    case 'pending':
      return 'bg-amber-100 text-amber-800';
    case 'never':
    default:
      return 'bg-gray-100 text-gray-600';
  }
}

export function u3121NasSyncStatusLabelKey(status: U3500NasSyncStatus): string {
  switch (status) {
    case 'success':
      return 'lblNasSyncSuccess';
    case 'error':
      return 'lblNasSyncError';
    case 'pending':
      return 'lblNasSyncPending';
    case 'never':
    default:
      return 'lblNasSyncNever';
  }
}

/** Formate un instant ISO UTC pour affichage dans le fuseau org actif. */
export function u3121FormatNasSyncLastAt(
  iso: string | null | undefined,
  locale: string,
  timeZone: string = u2000GetActiveDisplayTimezone()
): string | null {
  if (!iso?.trim()) {
    return null;
  }
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return null;
  }
  const intlLocale = locale.startsWith('fr') ? 'fr-CA' : 'en-CA';
  return new Intl.DateTimeFormat(intlLocale, {
    dateStyle: 'medium',
    timeStyle: 'short',
    timeZone,
  }).format(date);
}
